import { Injectable, inject } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client';
import { SaveFolderInput, Scalars, SetReportFolderInput, SetScheduleFolderInput } from '@core/types';
import { Apollo, MutationResult } from 'apollo-angular';
import { Observable } from 'rxjs';
import { DELETE_FOLDER, GET_ALL_USER_FOLDERS, ISaveFolderResponse, IUserFoldersResponse, SAVE_FOLDER, SET_REPORT_FOLDER, SET_SCHEDULE_FOLDER } from './user-folders-api-queries';

@Injectable({
    providedIn: 'root'
})
export class UserFoldersApiService {
    private _apollo = inject(Apollo);

    public getAllUserFolders(): Observable<ApolloQueryResult<IUserFoldersResponse>> {
        return this._apollo.use('core').query({ query: GET_ALL_USER_FOLDERS });
    }

    public saveFolder(criteria: SaveFolderInput): Observable<MutationResult<ISaveFolderResponse>> {
        return this._apollo.use('core').mutate({
            mutation: SAVE_FOLDER,
            variables: { saveFolderCriteria: criteria }
        });
    }

    public deleteFolder(criteria: number): Observable<MutationResult<Scalars>> {
        return this._apollo.use('core').mutate({
            mutation: DELETE_FOLDER,
            variables: { folderId: criteria }
        });
    }

    public setReportFolder(criteria: SetReportFolderInput) {
        return this._apollo.use('core').mutate({
            mutation: SET_REPORT_FOLDER,
            variables: { reportFolderInput: criteria }
        });
    }

    public setScheduleFolder(criteria: SetScheduleFolderInput) {
        return this._apollo.use('core').mutate({
            mutation: SET_SCHEDULE_FOLDER,
            variables: { scheduleFolderInput: criteria }
        });
    }
}
